import commonAxios from "@/views/csr/common/axios";

const chatApiService = {
  async createChat(slug, message) {
    commonAxios.setHeader();
    const response = await commonAxios.post("/chat", {
      chat_room_slug: slug,
      message,
    });
    return response.data || null;
  },

  async getChats(slug, page) {
    commonAxios.setHeader();
    const response = await commonAxios.get(
      `/chat?chat_room_slug=${slug}&page=${page}&per_page=15`
    );
    return response.data || null;
  },

  async getRooms({ page, sort, search, status }) {
    commonAxios.setHeader();
    const url = `/chat/room?${sort}&page=${page}${
      search ? `&search=${search}` : ``
    }${status ? `&status=${status}` : ``}`;
    const response = await commonAxios.get(url);
    return response.data || null;
  },

  async updateRoom(roomID, formData) {
    commonAxios.setHeader();
    const response = await commonAxios.post(`/chat/room/${roomID}`, formData);
    return response.data || null;
  },
};

export default chatApiService;
